import { onError } from "apollo-link-error";

import Log from "utils/log";

/*
  onError receives a callback in the event a GraphQL or network error occurs.
  @TODO: Connect this to Sentry.
*/
const errorLink = onError(({ graphQLErrors, networkError, operation }) => {
  if (graphQLErrors)
    graphQLErrors.map(({ message, location, path }) => {
      if (operation) {
        Log.error(
          `[GraphQL error]: Message: ${message}, Location: ${location}, Path: ${path}. [Operation details]: ${JSON.stringify(
            operation
          )}`
        );
      } else {
        Log.error(
          `[GraphQL error]: Message: ${message}, Location: ${location}, Path: ${path}`
        );
      }
    });
  if (networkError) {
    if (operation) {
      Log.error(
        `[Network error]: ${networkError}. [Operation details]: ${JSON.stringify(
          operation
        )}`
      );
    } else {
      Log.error(`[Network error]: ${networkError}`);
    }
  }
});

export default errorLink;
